"use client";
import React, { useEffect } from "react";

type IPropType = {
  isVideoOpen: boolean;
  onHide: () => void;
  videoId: string;
  vimeoPlayer?: boolean;
};

// Simple modal video using native dialog and YouTube/Vimeo embed
const VideoPopup = ({
  isVideoOpen,
  onHide,
  videoId = "TYYf8zYjP5k",
  vimeoPlayer,
}: IPropType) => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (isVideoOpen) {
      setShow(true);
      document.body.style.overflow = "hidden";
    } else {
      setShow(false);
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isVideoOpen]);

  if (!isVideoOpen) return null;

  const src = vimeoPlayer
    ? `https://player.vimeo.com/video/${videoId}?autoplay=1`
    : `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  const modalStyles: React.CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.7)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.3s cubic-bezier(.4,0,.2,1)",
    opacity: 1,
  };

  const videoContainerBase: React.CSSProperties = {
    position: "relative",
    width: "90vw",
    maxWidth: 800,
    aspectRatio: "16/9",
    background: "#000",
    boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
    overflow: "hidden",
    transform: "translateY(40px)",
    opacity: 0,
    transition:
      "opacity 0.4s cubic-bezier(.4,0,.2,1), transform 0.4s cubic-bezier(.4,0,.2,1)",
  };

  const videoContainerActive: React.CSSProperties = {
    ...videoContainerBase,
    transform: "translateY(0)",
    opacity: 1,
  };

  const closeBtnStyles: React.CSSProperties = {
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 2,
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    paddingTop: 2,
    paddingRight: 10,
    cursor: "pointer",
    fontSize: 28,
    lineHeight: 1,
    transition: "background 0.2s",
  };

  return (
    <div
      style={{ ...modalStyles, opacity: show ? 1 : 0 }}
      onClick={onHide}
      aria-modal="true"
      role="dialog"
    >
      <div
        style={show ? videoContainerActive : videoContainerBase}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onHide}
          style={closeBtnStyles}
          aria-label="Close video"
        >
          ×
        </button>
        <iframe
          src={src}
          width="100%"
          height="100%"
          style={{ border: 0, width: "100%", height: "100%" }}
          allow="autoplay; fullscreen"
          allowFullScreen
          title="Video"
        />
      </div>
    </div>
  );
};

export default VideoPopup;
